import React, { Component, PropTypes } from 'react';
import idx from 'idx';
import debounce from 'lodash/debounce';
import VotingTile from 'focus_groups/containers/voting_tile';
import StarRating from 'common/components/star_rating';
import { MAX_COMMENT_LENGTH } from 'focus_groups/constants';

export default class VotingFormTile extends Component {
  constructor(props) {
    const { votes, params } = props;

    super(props);

    this.state = {
      score: idx(votes, _ => _[params.participantId].score) || 0,
      comment: idx(votes, _ => _[params.participantId].comment) || ''
    };

    this.updateScore = this.updateScore.bind(this);
    this.updateComment = this.updateComment.bind(this);
    this.vote = this.vote.bind(this);
    this.isValid = this.isValid.bind(this);
  }

  isValid() {
    return this.state.comment.length <= MAX_COMMENT_LENGTH;
  }

  updateScore(score) {
    this.setState({ score }, this.vote);
  }

  updateComment(e) {
    this.setState({ comment: e.target.value }, this.vote);
  }

  vote = debounce(() => {
    if (this.isValid()) {
      this.props.vote(this.state);
    }
  }, 500)

  render() {
    const { score, comment } = this.state;
    const valid = this.isValid();

    return (
      <VotingTile {...this.props}>
        <div className="form-wrapper">
          <StarRating initialRate={score} onChange={this.updateScore} extraClasses="lg" />
          <textarea value={comment} onChange={this.updateComment} className="form-control"
            placeholder="Comment on this design..." rows={4} />
          { !valid &&
          <span className="error-msg text-danger">
            No more than { MAX_COMMENT_LENGTH } characters are allowed.
          </span> }
        </div>
      </VotingTile>
    );
  }
}

VotingFormTile.propTypes = {
  vote: PropTypes.func.isRequired,
  votes: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./focus_groups/components/voting_form_tile.jsx